// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.courseOverCover{

    position: relative;
    margin-bottom: 30px;

}

.courseHeading{
    margin-left: 30px;
   
}

.listOne{
    /* background-color: red; */
    width: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    /* flex: 1; */
    justify-content: space-between;
    padding: 0 30px;
    margin-top: 17px;

}
.listOne button{
   
    min-width: 200px;
    flex-grow: 1;
    padding: 25px 0;
    margin-right: 20px;
    border-radius: 5px;
    border: 0.1px solid gray;
    cursor: pointer;
    color: #003300;
    background-color: white;

}
.listOne button:hover{
   
 background-color: black;
 color: white;
}
.listOne .linkItem:hover{
   
 background-color: black;
 color: white;
}

.listOne button:last-child {
    /* background-color: red; */
    margin-right: 0; /* Remove margin for the last button */
}

@media screen and (max-width: 730px){ 
    
    .listOne button{
        margin-bottom: 17px;
    }
    .listOne button:last-child {
        /* background-color: red; */
        margin-right: 20px /* Remove margin for the last button */
    }

}`, "",{"version":3,"sources":["webpack://./src/Components/CourseOverview/CourseOverview.css"],"names":[],"mappings":";;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;;AAEpB;AACA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,cAAc;IACd,uBAAuB;;AAE3B;AACA;;CAEC,uBAAuB;CACvB,YAAY;AACb;AACA;;CAEC,uBAAuB;CACvB,YAAY;AACb;;AAEA;IACI,2BAA2B;IAC3B,eAAe,EAAE,sCAAsC;AAC3D;;AAEA;;IAEI;QACI,mBAAmB;IACvB;IACA;QACI,2BAA2B;QAC3B,iBAAiB,EAAE,sCAAsC;IAC7D;;AAEJ","sourcesContent":["\n\n.courseOverCover{\n\n    position: relative;\n    margin-bottom: 30px;\n\n}\n\n.courseHeading{\n    margin-left: 30px;\n   \n}\n\n.listOne{\n    /* background-color: red; */\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    /* flex: 1; */\n    justify-content: space-between;\n    padding: 0 30px;\n    margin-top: 17px;\n\n}\n.listOne button{\n   \n    min-width: 200px;\n    flex-grow: 1;\n    padding: 25px 0;\n    margin-right: 20px;\n    border-radius: 5px;\n    border: 0.1px solid gray;\n    cursor: pointer;\n    color: #003300;\n    background-color: white;\n\n}\n.listOne button:hover{\n   \n background-color: black;\n color: white;\n}\n.listOne .linkItem:hover{\n   \n background-color: black;\n color: white;\n}\n\n.listOne button:last-child {\n    /* background-color: red; */\n    margin-right: 0; /* Remove margin for the last button */\n}\n\n@media screen and (max-width: 730px){ \n    \n    .listOne button{\n        margin-bottom: 17px;\n    }\n    .listOne button:last-child {\n        /* background-color: red; */\n        margin-right: 20px /* Remove margin for the last button */\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
